import * as $ from 'jquery';
import * as scrollmonitor from 'scrollmonitor';
var Scrollmonitor = (function () {
    function Scrollmonitor(config) {
        this.config = {
            classes: {
                aboveViewport: 'scmo-above-vp',
                belowViewport: 'scmo-below-vp',
                enterBottom: 'scmo-enter-bottom',
                enterTop: 'scmo-enter-top',
                inViewport: 'scmo-in-vp',
                init: 'scmo-init',
                outViewport: 'scmo-out-vp',
                visitedViewPort: 'scmo-visited-vp',
            },
            selector: '.scrollmonitor',
        };
        this.allWatchersAssigned = false;
        this.watchers = [];
        if (config) {
            this.config = $.extend({}, this.config, config);
        }
    }
    Scrollmonitor.prototype.updateItems = function () {
        var _this = this;
        $(this.config.selector).each(function (idx, element) {
            if (!$(element).hasClass(_this.config.classes.init)) {
                _this.addWatcherForElement($(element));
            }
        });
        for (var _i = 0, _a = this.watchers; _i < _a.length; _i++) {
            var watcher = _a[_i];
            this.watcherUpdate(watcher);
        }
        this.checkWatcherClasses();
    };
    Scrollmonitor.prototype.destroyAllItems = function () {
        $(this.config.selector).removeClass(this.config.classes.init);
        for (var _i = 0, _a = this.watchers; _i < _a.length; _i++) {
            var watcher = _a[_i];
            watcher.destroy();
        }
    };
    Scrollmonitor.prototype.init = function () {
        var _this = this;
        $(window).on('load', function () {
            _this.$scrollElements = $(_this.config.selector);
            _this.$scrollElements.each(function (idx, element) {
                _this.addWatcherForElement($(element));
            });
            _this.allWatchersAssigned = true;
            _this.checkWatcherClasses();
        });
    };
    Scrollmonitor.prototype.addWatcherForElement = function ($element) {
        var _this = this;
        var resizeTimeout;
        var elementWatcher = scrollmonitor.create($element);
        elementWatcher.lock();
        elementWatcher.enterViewport(function (event, watcher) {
            _this.setViewportClasses(watcher);
        });
        elementWatcher.exitViewport(function (event, watcher) {
            _this.watcherUpdate(elementWatcher);
            _this.setViewportClasses(watcher);
        });
        $(window).on('resize', function () {
            window.clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(function () {
                _this.watcherUpdate(elementWatcher);
            }, 1000);
        });
        $element.addClass(this.config.classes.init);
        this.setViewportClasses(elementWatcher);
        this.watchers.push(elementWatcher);
    };
    Scrollmonitor.prototype.watcherUpdate = function (watcher) {
        watcher.unlock();
        watcher.recalculateLocation();
        watcher.lock();
    };
    Scrollmonitor.prototype.checkWatcherClasses = function () {
        for (var _i = 0, _a = this.watchers; _i < _a.length; _i++) {
            var watcher = _a[_i];
            this.setViewportClasses(watcher);
        }
    };
    Scrollmonitor.prototype.setViewportClasses = function (watcher) {
        var $item = $(watcher.watchItem);
        var enteredTop = false;
        var enteredBottom = false;
        var inViewport = watcher.isInViewport;
        var aboveViewport = (watcher.isAboveViewport && !watcher.isInViewport);
        var belowViewport = (watcher.isBelowViewport && !watcher.isInViewport);
        if (this.allWatchersAssigned) {
            enteredTop = inViewport && watcher.wasAbove;
            enteredBottom = inViewport && watcher.wasBelow;
            if (inViewport) {
                $item.addClass(this.config.classes.visitedViewPort);
            }
        }
        if (watcher.wasIn !== inViewport) {
            $item.toggleClass(this.config.classes.enterTop, enteredTop);
            $item.toggleClass(this.config.classes.enterBottom, enteredBottom);
            $item.toggleClass(this.config.classes.inViewport, inViewport);
            $item.toggleClass(this.config.classes.outViewport, !inViewport);
            $item.toggleClass(this.config.classes.aboveViewport, aboveViewport);
            $item.toggleClass(this.config.classes.belowViewport, belowViewport);
        }
        watcher.wasIn = inViewport;
        watcher.wasAbove = aboveViewport;
        watcher.wasBelow = belowViewport;
    };
    return Scrollmonitor;
}());
export { Scrollmonitor };
//# sourceMappingURL=scrollmonitor.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@pixelart/scrollmonitor/dist/scrollmonitor.class.js
// module id = 49
// module chunks = 0